import { Platform, Share } from 'react-native'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

import { API_ENDPOINTS } from '../../../constants/api'

export type UserDataExportApiClient = <T = unknown>(
  endpoint: string,
  config?: AxiosRequestConfig,
) => Promise<AxiosResponse<T>>

function parseAttachmentFilename(contentDisposition: string | undefined): string {
  if (!contentDisposition) return 'zporti-data-export.json'
  const match = /filename="([^"]+)"/i.exec(contentDisposition)
  return match?.[1] || 'zporti-data-export.json'
}

function normalizeToString(data: unknown): string {
  if (typeof data === 'string') return data
  if (data === null || data === undefined) return ''
  if (typeof data === 'object') return JSON.stringify(data, null, 2)
  return String(data)
}

export async function downloadUserDataExport(apiClient: UserDataExportApiClient): Promise<void> {
  const response = await apiClient<string>(API_ENDPOINTS.users.dataExport, {
    method: 'GET',
    responseType: Platform.OS === 'web' ? 'blob' : 'text',
  })

  const rawContentDisposition = response.headers['content-disposition']
  const contentDisposition = typeof rawContentDisposition === 'string' ? rawContentDisposition : undefined
  const filename = parseAttachmentFilename(contentDisposition)

  if (Platform.OS === 'web') {
    if (typeof document === 'undefined' || typeof URL === 'undefined') {
      throw new Error('Download is not available on this platform')
    }
    const blob = (response.data as unknown) instanceof Blob
      ? (response.data as unknown as Blob)
      : new Blob([normalizeToString(response.data)], { type: 'application/json' })
    const objectUrl = URL.createObjectURL(blob)
    try {
      const anchor = document.createElement('a')
      anchor.href = objectUrl
      anchor.download = filename
      anchor.rel = 'noopener'
      document.body.appendChild(anchor)
      anchor.click()
      anchor.remove()
    } finally {
      URL.revokeObjectURL(objectUrl)
    }
    return
  }

  const jsonText = normalizeToString(response.data)
  await Share.share({
    title: filename,
    message: jsonText,
  })
}

